import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Modal, } from 'react-bootstrap'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls'
import * as Yup from "yup";
import PersonalDetailsReport from '../AppplicationForm/PersonalDetailsReport'
import Swal from 'sweetalert2'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { ERROR_MSG } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { useDispatch, useSelector } from 'react-redux';
import { FaCopy } from 'react-icons/fa';
import { IoCheckmarkSharp } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { current } from '@reduxjs/toolkit';
import { appInitValues, appValidationSchema } from '../Posts/Preview';

export default function TetPreview({ handleClose }) {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    const dispatch = useDispatch();
   
    const [papersData, setPapersData] = useState();
    const getpostDataFunction = () => {
        let villUrl = config.url.DSC_URL + "tet-candidate-eligible-papers";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                setPapersData(response?.data?.candidateposts)
            }
            else {
                setPapersData([])
            }
        });
    };
    let navigate = useNavigate()
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: appInitValues,
        onSubmit: (values) => {
            if (papersData?.length > 0) {
                Swal.fire({
                    title: 'Are you Sure Want to Submit?',
                    text: "Details furnished in the application are final. Subsequent requests for corrections will not be entertained for wrong filling of application.",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Submit",
                    cancelButtonText: "Edit",
                }).then((res) => {
                    if (res.isConfirmed) {
                        let url = config.url.DSC_URL + "tet-candidate-confirmation"
                        CommonAxiosPost(url, values).then((ress) => {
                            if (ress?.data?.status === true) {
                                Sweetalert('Successfully Confirmed', "success")
                                dispatch({
                                    type: "SHOW_TAB_DETAILS",
                                    payload: {
                                        latestTab: 3,
                                        confirm: true
                                    }
                                })
                                handleClose()
                            }
                            else {
                                Sweetalert(ress?.data?.sdesc, "error")
                            }
                        })
                    }
                    else if (res.isDismissed) {
                        navigate('/ProfileDetailsWay')
                    }
                    else {
                        handleClose()
                    }
                })
            }
            else {

                Swal.fire({

                    html: `As per the data provided (Academic Details/Professional qualifications/Other).
                    You are not eligible for any notified Tet Papers. Please Check G.O. and your Qualification details once for the Eligibility Criteria`,
                    icon: "warning",
                    confirmButtonColor: '#3085d6',
                })
            }

        },
        validationSchema: appValidationSchema,
    })
    const [showUgPgPqData, setUgPgPqData] = useState([])
    const [showSevenData, setSevenData] = useState([])
    const [showSSCInterData, setSSCInterData] = useState([])
    const [showTETData, setTETData] = useState([])

    const [showData, setData] = useState()

    function getStudyData() {
        let Url = config.url.DSC_URL + "candidate-study-details"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                if (res?.data?.sevenyear_status === true) {
                    setSevenData(res?.data?.sevenyear)
                }
                if (res?.data?.ugpgpq_status === true) {
                    setUgPgPqData(res?.data?.ugpgpq)
                }
                if (res?.data?.sscinter_status === true) {
                    setSSCInterData(res?.data?.sscinter[0])
                }
                if (res?.data?.tet_status === true) {
                    setTETData(res?.data?.tet)
                }
                if (res?.data?.candidatereg_status === true) {
                    setData(res?.data?.candidatereg[0])
                    const casteId = res?.data?.candidatereg[0]?.certificate_id;
                    if (casteId) {
                        localStorage.setItem("caste", casteId);
                    } else {
                        console.warn("No certificate_id found");
                    }

                }
            }
        })
    }
    useEffect(() => {

        getStudyData()
        getpostDataFunction()
    }, [])
    const [copied, setCopied] = useState(false);
    const handleCopyText = () => {
        const textToCopy = document.getElementById('textToCopy').innerText;
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                console.log('Text copied to clipboard');
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 3000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };


    return (
        <React.Fragment>

            {papersData?.length > 0 ?
                <FormikProvider value={Formik}>
                    <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                                <div className="heading-main">
                                    <h3 className="main-title">Candidate Details Confirmation  - <span style={{ color: 'brown' }} id='textToCopy'>{loginreducer?.username}</span>
                                        &nbsp; {copied ? <><IoCheckmarkSharp color='green' size={30} />Copied! </> : <FaCopy onClick={() => { handleCopyText(); }} />}
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                      <BasicDetailsCheck Formik={Formik} showData={showData}/>
                      <EducationalCheck showSevenData={showSevenData} showData={showData}/>
                      <SSCCheck showSSCInterData={showSSCInterData}/>
                      <InterCheck showSSCInterData={showSSCInterData}/>
                      <DegreeCheck showUgPgPqData={showUgPgPqData}/>
                      <PGCheck showUgPgPqData={showUgPgPqData}/>
                      <PQCheck showUgPgPqData={showUgPgPqData}/>
                      <TETCheck showTETData={showTETData}/>
                      <TETPapersCheck papersData={papersData}/>
                    </Form>
                </FormikProvider>
                :<div className='mb-4'>
                    <h3 className="text-error mt-4 border p-3 fs-6 w-100 ">
                        <strong>Dear {loginreducer?.applicant_name},</strong><pre />
                        As per the data provided (Academic Details/Professional qualifications/Other).
                        You are not eligible for any notified Tet Papers. Please Check G.O. and your Qualification details once for the Eligibility Criteria.
                        <span>  <i style={{ background: "#2a9d8f" }}
                            className="badge badge-success forgot fw-bold"
                            onClick={() => navigate('/ProfileDetailsWay')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    navigate('/ProfileDetailsWay')
                                }
                            }}
                            data-toggle="tooltip" animation="true"
                        > Click Here </i> </span> to Edit the application.

                    </h3>
                </div>

            }
        </React.Fragment>
    )
}
export const BasicDetailsCheck = (props)=>{
    const{Formik,showData}=props;
    return(
        <>
             <div className="personal-head">
                            <span>Personal Details</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <PersonalDetailsReport Formik={Formik} showdata={showData} preview={true} />
                            <div className='px-1 pb-2 text-end'>
                                <ErrorMessage
                                    name="personalDetailsCheck"
                                    component="span"
                                    className="text-error"
                                /> &nbsp;
                                <button className='btn btn-outline-light' type='button'
                                    style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                    &nbsp; <Field name="personalDetailsCheck"
                                        id='personalDetailsCheck'
                                        type="checkbox"
                                        style={{ width: '17px', height: '17x' }}
                                    />&nbsp;&nbsp;<label htmlFor='personalDetailsCheck'>Verified & Correct</label>&nbsp;
                                </button>

                            </div>
                        </div>
        </>
    )
}
export const EducationalCheck = (props)=>{
    const{showSevenData,showData}=props;
    return(<>
          <div className="personal-head mt-2">
                            <span>Basic Education Details</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3" >
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', borderCollapse: 'collapse', }}>
                                    <tbody>
                                        <tr>
                                            <th style={{ width: '25%' }}>{showData?.type_of_study} Classes</th>
                                            <th style={{ width: '25%' }}>District</th>
                                            <th style={{ width: '25%' }}>{showData?.type_of_study} Classes</th>
                                            <th style={{ width: '25%' }}>District</th>
                                        </tr>
                                        <tr>
                                            <td>{showSevenData[0]?.class_no}<sup>Th</sup>Class </td>
                                            <td>{showSevenData[0]?.dist_name}</td>
                                            <td>{showSevenData[1]?.class_no}<sup>Th</sup>Class</td>
                                            <td>{showSevenData[1]?.dist_name}</td>
                                        </tr>
                                        <tr>
                                            <td>{showSevenData[2]?.class_no}<sup>Th</sup>Class</td>
                                            <td>{showSevenData[2]?.dist_name}</td>
                                            <td>{showSevenData[3]?.class_no}<sup>Th</sup>Class</td>
                                            <td>{showSevenData[3]?.dist_name}</td>
                                        </tr>
                                        <tr>
                                            <td>{showSevenData[4]?.class_no}<sup>Th</sup>Class</td>
                                            <td>{showSevenData[4]?.dist_name}</td>
                                            <td>{showSevenData[5]?.class_no}<sup>Th</sup>Class</td>
                                            <td>{showSevenData[5]?.dist_name}</td>
                                        </tr>

                                        <tr>
                                            <td>{showSevenData[6]?.class_no}<sup>Th</sup>Class</td>
                                            <td colSpan={3}>{showSevenData[6]?.dist_name}</td>

                                        </tr>
                                        {showData?.is_telangana === true && <tr><td colSpan={3}>Are You migrated from Telangana after bifurcation of State i.e on 02/06/2014
                                            and are you claiming under the G.O MS No 133:</td>
                                            <th>{showData?.is_telangana === true ? <React.Fragment>Yes.</React.Fragment> : 'No'}</th></tr>
                                        }
                                        <tr><td>Local District</td>
                                            <th colSpan={3}>{showData?.is_telangana === true ? showData?.claiming_district_name : showData?.local_dist_name}</th></tr>
                                    </tbody>
                                    <tfoot className=''>
                                        <tr className='text-end'>
                                            <td colSpan={4}>
                                                <ErrorMessage
                                                    name="basicEducationCheck"
                                                    component="span"
                                                    className="text-error"
                                                /> &nbsp;
                                                <button className='btn btn-outline-light' type='button'
                                                    style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                    <Field
                                                        name="basicEducationCheck"
                                                        type="checkbox"
                                                        style={{ width: '17px', height: '17px' }}
                                                    />&nbsp; Verified & Correct
                                                </button>
                                            </td></tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
    </>)}

export const SSCCheck = (props)=>{
    const{showSSCInterData}=props;
        return(<>
             <div className="personal-head mt-2">
                            <span>SSC or its Equivalent Qualification:</span>
                        </div>

                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3">
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th>Board</th>
                                            <th>Medium</th>
                                            <th>1st Language</th>
                                            <th>Year of Passing</th>
                                            <th>% of Marks</th>
                                            <th>Hall Ticket No.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>{showSSCInterData?.ssc_board_name}</td>
                                            <td>{showSSCInterData?.ssc_medium_name}</td>
                                            <td>{showSSCInterData?.ssc_first_language_name}</td>
                                            <td>{showSSCInterData?.ssc_year_of_pass}</td>
                                            <td>{showSSCInterData?.ssc_percentage}</td>
                                            <td>{showSSCInterData?.ssc_hall_ticket}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'>
                                            <td colSpan={6}>
                                                {showSSCInterData?.ssc_board_name ? ''
                                                    : <b className='text-center text-danger'>** You have not Studied SSC &emsp;</b>}

                                                <ErrorMessage
                                                    name="sscCheck"
                                                    component="span"
                                                    className="text-error"
                                                /> &nbsp;
                                                <button className='btn btn-outline-light' type='button'
                                                    style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                    <Field
                                                        name="sscCheck"
                                                        type="checkbox"
                                                        style={{ width: '17px', height: '17px' }}
                                                    />&nbsp;Verified & Correct
                                                </button>
                                            </td></tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
        </>)
    }

export const InterCheck = (props)=>{
    const{showSSCInterData}=props;
        return(<>
         <div className="personal-head mt-2">
                            <span>Intermediate or its Equivalent Qualification:</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3" style={{ overflow: 'visible' }}>
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{
                                        border: '2px solid lightblue',
                                        borderCollapse: 'collapse',
                                        width: '100%',
                                        tableLayout: 'fixed',
                                        wordWrap: 'break-word'
                                    }}>
                                    <thead>
                                        <tr>
                                            <th rowSpan={2}>Course</th>
                                            <th colSpan={4} className='text-center'>Subjects</th>
                                            <th rowSpan={2}>Board</th>
                                            <th rowSpan={2}>Medium</th>
                                            <th rowSpan={2}>2nd Language</th>
                                            <th rowSpan={2}>Year of Passing</th>
                                            <th rowSpan={2}>Hall Ticket No.</th>
                                            <th rowSpan={2}>% of Marks</th>

                                        </tr>
                                        <tr>
                                            <th>1</th><th>2</th><th>3</th><th>4</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr> <td>{showSSCInterData?.inter_course}</td>
                                            <td>{showSSCInterData?.inter_subject_1_name}</td>
                                            <td>{showSSCInterData?.inter_subject_2_name}</td>
                                            <td>{showSSCInterData?.inter_subject_3_name}</td>
                                            <td>{showSSCInterData?.inter_subject_4_name}</td>
                                            <td>{showSSCInterData?.inter_board_name}</td>
                                            <td>{showSSCInterData?.inter_medium_name}</td>
                                            <td>{showSSCInterData?.inter_second_language_name}</td>
                                            <td>{showSSCInterData?.inter_year_of_pass}</td>
                                            <td>{showSSCInterData?.inter_hall_ticket}</td>
                                            <td>{showSSCInterData?.inter_percentage}</td>

                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'><td colSpan={11}>
                                            {showSSCInterData?.inter_course ? ''
                                                : <b className='text-center text-danger'>** You have not Studied Intermediate &emsp;</b>}

                                            <ErrorMessage
                                                name="interCheck"
                                                component="span"
                                                className="text-error"
                                            />&nbsp;
                                            <button className='btn btn-outline-light' type='button'
                                                style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                <Field
                                                    name="interCheck"
                                                    type="checkbox"
                                                    style={{ width: '17px', height: '17px' }}
                                                />&nbsp;Verified & Correct
                                            </button>
                                        </td></tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
        </>)
    }

export const DegreeCheck = (props)=>{
    const{showUgPgPqData}=props;
        return(<>
              <div className="personal-head mt-2">
                            <span>Degree or its Equivalent Qualification:</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3" style={{ overflow: 'visible' }} >
                                <table className="table table-condensed table-bordered table-striped mb-0 mt-0 px-0" width={50} height={100}
                                    // style={{ border: '2px solid lightblue', borderCollapse: 'collapse' }}
                                    style={{
                                        border: '2px solid lightblue',
                                        borderCollapse: 'collapse',
                                        width: '100%',
                                        tableLayout: 'fixed',
                                        wordWrap: 'break-word'
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th rowSpan={2}>Course</th>
                                            <th colSpan={4} className='text-center'> Subjects</th>
                                            <th rowSpan={2}> University</th>
                                            <th rowSpan={2}> Medium</th>
                                            <th rowSpan={2}> 2nd Language</th>
                                            <th rowSpan={2}> Year of Passing</th>
                                            <th rowSpan={2}> Hall Ticket No.</th>
                                            <th rowSpan={2}>% of Marks</th>

                                        </tr>
                                        <tr>
                                            <th>1</th><th>2</th><th>3</th><th>4</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showUgPgPqData?.filter((val) => val.study_type === "UG")?.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{item?.course_name}</td>
                                                    <td>{item?.subject_1_name}</td>
                                                    <td>{item?.subject_2_name}</td>
                                                    <td>{item?.subject_3_name}</td>
                                                    <td>{item?.subject_4_name}</td>
                                                    <td>{item?.univ_name}</td>
                                                    <td>{item?.medium_name}</td>
                                                    <td>{item?.second_language_name}</td>
                                                    <td>{item?.year_of_pass}</td>
                                                    <td>{item?.hall_ticket}</td>
                                                    <td>{item?.percentage}</td>

                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'>
                                            <td colSpan={11}>
                                                {showUgPgPqData?.filter((val) => val.study_type === "UG").length > 0 ? ''
                                                    : <b className='text-center text-danger'>** You have not selected any degree &emsp;</b>}
                                                <ErrorMessage
                                                    name="ugCheck"
                                                    component="span"
                                                    className="text-error"
                                                /> &nbsp;
                                                <button className='btn btn-outline-light' type='button'
                                                    style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                    <Field
                                                        name="ugCheck"
                                                        type="checkbox"
                                                        style={{ width: '17px', height: '17px' }}
                                                    />&nbsp; Verified & Correct
                                                </button>
                                            </td></tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
        </>)}

export const PGCheck = (props)=>{
    const{showUgPgPqData}=props;
        return(<> <div className="personal-head mt-2">
                            <span>Post Graduation</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3" >
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', borderCollapse: 'collapse', }}>
                                    <thead>
                                        <tr> <th>Course</th>
                                            <th> Subject</th>
                                            <th> University</th>
                                            <th> Medium</th>
                                            <th> Year of Passing</th>
                                            <th> Hall Ticket No.</th>
                                            <th>% of Marks</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showUgPgPqData?.filter((val) => val.study_type === "PG")?.map((item, i) => {
                                            return (
                                                <tr key={i}> <td>{item?.course_name}</td>
                                                    <td>{item?.subject_1_name}</td>
                                                    <td>{item?.univ_name}</td>
                                                    <td>{item?.medium_name}</td>
                                                    <td>{item?.year_of_pass}</td>
                                                    <td>{item?.hall_ticket}</td>
                                                    <td>{item?.percentage}</td>

                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'><td colSpan={9}>
                                            {showUgPgPqData?.filter((val) => val.study_type === "PG").length > 0 ? ''
                                                : <b className='text-center text-danger'>** You have not selected any PG &emsp;</b>}

                                            <ErrorMessage
                                                name="pgCheck"
                                                component="span"
                                                className="text-error"
                                            /> &nbsp;
                                            <button className='btn btn-outline-light' type='button'
                                                style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                <Field
                                                    name="pgCheck"
                                                    type="checkbox"
                                                    style={{ width: '17px', height: '17px' }}
                                                />&nbsp; Verified & Correct
                                            </button>
                                        </td></tr>
                                    </tfoot>
                                </table>
                            </div>

                        </div></>)}

export const PQCheck = (props)=>{
    const{showUgPgPqData}=props;
        return(<>   <div className="personal-head mt-2">
                            <span>Professional Qualification </span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3" >
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', borderCollapse: 'collapse', }}>
                                    <thead>
                                        <tr>
                                            <th> Qualification</th>
                                            <th> Methodology 1</th>
                                            <th> Methodology 2</th>
                                            <th>University</th>
                                            <th>Medium</th>
                                            <th> Year of Passing</th>
                                            <th>Recieved Final Year Result?</th>
                                            <th>% of Marks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showUgPgPqData?.filter((val) => val.study_type === "PQ")?.map((item, i) => {
                                            return (
                                                <tr key={i}>

                                                    <td>{item?.course_name}</td>
                                                    <td>{item?.subject_1_name}</td>
                                                    <td>{item?.subject_2_name}</td>
                                                    <td>{item?.univ_name}</td>
                                                    <td>{item?.medium_name}</td>
                                                    <td>{item?.year_of_pass}</td>
                                                    <td>{item?.has_final_year_result ? item?.has_final_year_result : "NA"}</td>
                                                    <td>{item?.percentage ? item?.percentage : "NA"}</td>

                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'><td colSpan={8}>
                                            <ErrorMessage
                                                name="pqCheck"
                                                component="span"
                                                className="text-error"
                                            /> &nbsp;
                                            <button className='btn btn-outline-light' type='button'
                                                style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                <Field
                                                    name="pqCheck"
                                                    type="checkbox"
                                                    style={{ width: '17px', height: '17px' }}
                                                />&nbsp; Verified & Correct
                                            </button>
                                        </td></tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
        </>)}
export const TETCheck = (props)=>{
    const{showTETData}=props;
        return(<> 
        <div className="personal-head mt-2">
                            <span>APTET/CENTRAL TET DETAILS (CTET)</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3">
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', borderCollapse: 'collapse', }}>
                                    <thead>
                                        <tr> <th>Tet Type</th>
                                            <th>Paper</th>
                                            <th>Year of Passing</th>
                                            <th>HallTicket No.</th>
                                            <th>Marks</th></tr>
                                    </thead>
                                    <tbody>
                                        {showTETData?.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{item?.tet_type}</td>
                                                    <td>{item?.paper_name}</td>
                                                    <td>{item?.year_of_pass}</td>
                                                    <td>{item?.hall_ticket}</td>
                                                    <td>{item?.marks}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'><td colSpan={8}>
                                            {showTETData?.length > 0 ? <></>
                                                : <b className='text-center text-danger'>** You have not given any tet details&emsp;</b>}
                                            <ErrorMessage
                                                name="tetCheck"
                                                component="span"
                                                className="text-error"
                                            />&nbsp;
                                            <button className='btn btn-outline-light' type='button'
                                                style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                <Field
                                                    name="tetCheck"
                                                    type="checkbox"
                                                    style={{ width: '17px', height: '17px' }}
                                                />&nbsp;Verified & Correct
                                            </button>
                                        </td></tr></tfoot>
                                </table>
                            </div>

                        </div>
                        
        </>)}
export const TETPapersCheck = (props)=>{
    const{papersData}=props;
        return(<> 
          <div className="personal-head mt-2">
                            <span>Eligible Papers</span>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive px-1 mb-3">
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Paper</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {papersData ? papersData?.map((data, index) => {
                                            return (
                                                <tr key={index} id={index}>
                                                    <td>{index + 1}.</td>
                                                    <td>{data?.tet_paper_name}</td>
                                                </tr>
                                            )
                                        }) : <></>}

                                    </tbody>
                                    <tfoot>
                                        <tr className='text-end'><td colSpan={5}>
                                            {papersData?.length > 0 ? <>
                                                <ErrorMessage
                                                    name="postCheck"
                                                    component="span"
                                                    className="text-error"
                                                /> &nbsp;
                                                <button className='btn btn-outline-light' type='button'
                                                    style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                    <Field
                                                        name="postCheck"
                                                        type="checkbox"
                                                        style={{ width: '17px', height: '17px' }}
                                                    />&nbsp;Verified & Correct
                                                </button>
                                            </>
                                                : <b className='text-center text-danger'>** Based on your qualifications and the provided data, you are not eligible for any of the notified posts. &emsp;</b>}

                                        </td></tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className='float-end mb-4 mt-2 px-1'>
                                <Button variant="success" type="submit" className="submit-btn btn-success" >
                                    Confirm & save
                                </Button>
                            </div>
                        </div>
        </>)
}